<template>
    <div id="ContainerProvidersSetup">
        <div class="row">
            <div class="col-12">
                <MdTitle v-bind:Text="$t('Provider.Ptitle')" />
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                        <MdButton
                            v-bind:Label="$t('Provider.AddProvider')"
                            v-bind:ClassProp="
                                this.isReadOnly
                                    ? 'btn btn-primary my-3 btn-block'
                                    : 'btn btn-primary my-3 btn-block btn-login'
                            "
                            v-on:click="AddProvider"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Name="'btn_add_insurancesetup'"
                        >
                        </MdButton>
                    </div>
                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-9 mb-4'
                                : 'col-sm-12 col-md-12 mb-4'
                        "
                    >
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="SearchProvider()"
                                />
                                <div class="input-group-append">
                                    <MdButton
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        v-on:click="SearchProvider"
                                    >
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-toast id="error-toast" title="Error" static no-auto-hide>
                    {{ error_toast }}
                </b-toast>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <MdTitle
                        v-bind:Text="$t('Shared.SearchResult')"
                        v-bind:isSubtitle="true"
                        v-bind:Name="'T_TitleSearch'"
                    />
                
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="refTable"
                        :editIconEvent="EditProviderView"
                        v-bind:VisibleEditIcon="hasPermissionEdit()"
                        :deleteIconEvent="RemoveProvider"
                        v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction"
                    >
                    </MdTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '../../../../event-bus';
import Permission from '@/common/Permission';
import ProviderService from '@/services/provider.service';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'ProviderSetupList',
   
    data() {
        return {
            error_toast: '',
            ShowMessageIsEmpty: false,
            Mode: '',
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
                Status: true
            },
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            fields: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.Code'),
                    class: 'text-rigth'
                },{
                    key: 'company',
                    sortable: true,
                    label: this.$t('employee.Company'),
                    class: 'text-rigth'
                },
            ],

            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            selected: [],
            Header: {},
            isReadOnly: false,
            refTable: 'selectableTable',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    methods: {
        pageChanged(page) {
            this.currentPage = page;
            this.getProviders();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getProviders();
        },

        SearchProvider() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getProviders();
        },

        getProviders() {
            this.parameter.PageSize = this.perPage;
            this.parameter.PageNumber = this.currentPage;

            ProviderService.getFullProvidersNoTraining(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                    if (this.items.length === 0) {
                        this.ShowMessageIsEmpty = true;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

     
        EditProviderView(row) {
            this.Mode = 'Edit';
            this.$router.push({ name: 'ProviderSetupEdit', params: { id: row.code } });
        },

        RemoveProvider(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('ProvidersList.DeleteProvider'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_providerSetup'
                })
                .then(value => {
                    if (value) {
                        ProviderService.delete(row.code)
                            .then(() => {
                                const index = this.items.findIndex(
                                    item => item.code === row.code
                                ); // find the post index
                                if (~index) {
                                    // if the post exists in array
                                    this.items.splice(index, 1); //delete the post and refresh view
                                    this.getProviders(); //refresh listing
                                }
                            })
                            .catch(error => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        focusInput() {
            this.$refs.SearchPatient.focus();
        },

        onRowSelected(items) {
            this.selected = items;
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },

        clearSelected() {
            this.$refs.selectableTable.clearSelected();
        },

        selectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.selectRow(2);
        },

        unselectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.unselectRow(2);
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        AddProvider() {
            this.Mode = 'Add';
            this.emitDataforFavorites();
            EventBus.$emit('onUpdatedMenu', '');
            this.$router.push({ name: 'ProviderSetupAdd' }).catch(() => {});
        },

        info(item, index) {
            alert(item.FirstName, index);
        }
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getProviders();
        this.isReadOnly = false;
    }
};
</script>
